<template>
  <div>
    <h2 class="caption pt-4">
      <span class="text-uppercase">{{ $t("pages.dashboard.support_contacts.title") }}</span>
    </h2>
    <v-card class="elevation-0">
      <v-card-text class="text-body-2">
        <i18n path="pages.dashboard.support_contacts.payments" tag="div">
          <template #finance_email>
            <a
              :href="`mailto:${financeEmail}`"
            >
              {{ financeEmail }}
            </a>
          </template>
        </i18n>
        <i18n path="pages.dashboard.support_contacts.other" tag="div" class="mt-2">
          <template #link>
            <router-link :to="{ name: 'helpdesk' }">
              {{ $t("pages.dashboard.support_contacts.support_link") }}
            </router-link>
          </template>
        </i18n>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { SUPPORT_FINANCE_EMAIL } from "@/constants/supportContacts";

export default {
  name: "SupportContactsBlock",
  computed: {
    // Vue 2: импортированные константы недоступны напрямую в шаблоне,
    // поэтому прокидываем их через computed (без лишней реактивности data()).
    financeEmail() {
      return SUPPORT_FINANCE_EMAIL;
    }
  }
};
</script>

<style scoped lang="scss">

</style>
